export default function loadCss(name, path) {
  return new Promise(resolve => {
    var myCSS = document.createElement("link");
    myCSS.rel = "stylesheet";
    myCSS.href = path + "" + name + ".css";
    // insert it at the end of the head
    document.head.insertBefore(
      myCSS,
      document.head.childNodes[document.head.childNodes.length - 1].nextSibling
    );
    resolve();
  });
}
